import { useState } from 'react';

import Dashboard from './DashBoard';
import MemberBoard from './MemberBoard';
import JobReSend from './JobReSend';
import ProdCompare from './ProdCompare';
import Container from '../UI/atoms/Container';
import Text from '../UI/atoms/Text';
import Line from '../UI/atoms/Line';
import Grid from '../UI/atoms/Grid';
import { useParams } from 'react-router-dom';
import { WakeUp } from 'common/interface/props';
import Tab from 'components/UI/atoms/Tab';
import { TargetSolTypeRole } from 'common/common.constants';
import { ISearchData } from 'components/admin/interfaces/admin.interface';
import Statistics from 'components/admin/Statistics';

interface IProps {
  isIntegrated: boolean;
}

export default function Admin({ isIntegrated }: IProps) {
  const params = useParams();
  // 통합 어드민 페이지의 기본  값은 coupang
  const solType = isIntegrated ? 'COUPANG' : (params.solType!.toUpperCase() as WakeUp);

  // 연동관리 타입 (통계, 상세조회)
  const [adminType, setAdminType] = useState<string>('통계관리');

  const [searchData, setSearchData] = useState<ISearchData>({
    jobId: '',
    solType: TargetSolTypeRole.COUPANG,
  });

  // 연동관리 타입 변경 이벤트
  const changeAdmintype = (adminType: string) => {
    setAdminType(adminType);
  };

  // 작업 재시도 완료 이벤트
  const handleJobReSendComplete = (searchData: ISearchData) => {
    setAdminType('상세조회');
    setSearchData({
      jobId: searchData.jobId,
      solType: searchData.solType,
    });
  };

  return (
    <Container>
      <Grid bottom={10}>
        <Grid bottom={40}>
          <Text fontSize="2rem" fontWeight={600} color="#444">
            WAKEUP {adminType}
          </Text>
        </Grid>
        <Tab
          currentTab={adminType}
          tabNames={isIntegrated ? ['통계관리', '상세조회', '멤버조회', '작업 재시도', '상품 유사도'] : ['통계관리', '상세조회']}
          tabNodes={[
            <Statistics solType={solType} isIntegrated={isIntegrated} />,
            <Dashboard solType={solType} isIntegrated={isIntegrated} searchData={searchData} setSearchData={setSearchData} />,
            isIntegrated && <MemberBoard />,
            isIntegrated && <JobReSend onComplete={handleJobReSendComplete} />,
            isIntegrated && <ProdCompare />,
          ]}
          tabSwitchEvent={changeAdmintype}
          tabSwitchValues={isIntegrated ? ['통계관리', '상세조회', '멤버조회', '작업 재시도', '상품 유사도'] : ['통계관리', '상세조회']}
        />
      </Grid>
      <Line color="#e8e8e8" />
    </Container>
  );
}
